import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { Block as BlockIcon } from "@mui/icons-material";
import SecretaryPatientDetail from "../Secretary/PatientDetail";
import { useHasPermission } from "../../hooks/useHasPermission";
import EmptyState from "../../components/atoms/EmptyState";
import useAuth from "../../hooks/useAuth";
import { ClinicModulesContext } from "../../hooks/useClinicModule";
import { useGetClinicModulesMutation } from "../../store/clinicApi";

export default function AdminPatientDetail() {
  const canView = useHasPermission("admin-patients:view-detail");
  const { clinicId } = useParams();
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const [getModules] = useGetClinicModulesMutation();
  // Hasta detayı sekmeleri bu kliniğin modüllerine göre (bkz. useClinicModule).
  const [activeModules, setActiveModules] = useState(null);

  useEffect(() => {
    if (!token || !clinicId || !canView) return;
    getModules({ token, clinicId })
      .unwrap()
      .then((r) => setActiveModules(r?.data?.modules?.activeModules || null))
      .catch(() => setActiveModules(null));
  }, [token, clinicId, canView, getModules]);

  if (!canView) {
    return (
      <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <EmptyState
          variant="inline"
          icon={<BlockIcon />}
          title="Bu sayfayı görüntüleme yetkiniz yok."
        />
      </Box>
    );
  }

  return (
    <ClinicModulesContext.Provider value={activeModules}>
      <SecretaryPatientDetail />
    </ClinicModulesContext.Provider>
  );
}
